import {z} from '@hono/zod-openapi';

export const automarketplCredentialsSchema = z.object({
  apiKey: z.string().min(1),
  credentialKey: z.string().min(1),
});

export type AutomarketplCredentials = z.infer<typeof automarketplCredentialsSchema>;
